import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgInsurance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4 5.5s.324 11.405 7.938 14.78c7.968-3.375 7.42-15.086 7.42-15.086s-4.697-.206-6.095-1.302c-1.397-1.097-1.594-1.278-2.865 0C9.127 5.17 4 5.499 4 5.499Z"
      stroke="#17181A"
    />
    <path d="M11.803 8.478v6.363m-3.078-3.295h6.237" stroke="#17181A" />
  </svg>
);
const Memo = memo(SvgInsurance);
export default Memo;
